export const constants = {
    APP_ID: 'vipHub',
    LOCAL_STORAGE_KEYS : {
        TOKEN: 'com.toyota.tme.user.token',
        PROFILE: 'com.toyota.tme.user.customerProfile',
        ARTWORK: 'com.toyota.tme.user.artwork',
        QUIZ: 'com.toyota.tme.user.quizResults',
        GUEST: 'com.toyota.tme.user.guest_expires_at'
    },
    SSO_OVERLAY_TYPES: {
        LOGIN: 'login',
        REGISTER: 'register'
    },
    SSO_WRAPPER_ID: 'sso-wrapper',
    MEDIA_TYPES: {
        IMAGE: 'image',
        VIDEO: 'video'
    },
    INJECTION_ELEMENTS: {
        HEADER_SELECTOR: '.header-lexus'
    },
    GREETING_KEYS:{
        MORNING_GREETING: 'morningGreeting',
        AFTERNOON_GREETING: 'afternoonGreeting',
        EVENING_GREETING: 'eveningGreeting'
    },
    FIRST_NAME_PLACEHOLDER: '{{FIRST_NAME}}',
    PERSONALITY_TYPES: {
        FREE_SPIRIT: 'Free Spirit',
        SOPHISTICATED_TECHNOVATOR: 'Sophisticated Technovator'
    },
    ATMOSPHERES: {
        COOL: 'Cool',
        EMOTION: 'Emotion',
        ELEGANT: 'Elegant',
        RELAX: 'Relax'
    },
    SSO_HASH_PARAMETERS: {
        MODEL: 'model',
        REDIRECTION_PATH: 'redirectionPath',
        CONTEXT_NAME: 'contextName'
    },
    LBX_THEME_MAP: {
        cool: 'dark-theme',
        elegant: 'light-theme',
        emotion: 'dark-theme',
        lbx: 'light-theme',
        original_edition: 'dark-theme',
        relax: 'light-theme'
    }

};

